module.exports = __webpack_public_path__ + "assets/img/img-placeholder-reel-w720.7d6d4056.webp";